module.exports = __webpack_public_path__ + "img/ERC20.617bd68b.png";